var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_1127_7368)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9902 7.89131L16.9133 5.96813L16.9133 5.96812L16.9134 5.96811C17.5533 5.32813 17.8733 5.00814 18.0251 4.65304C18.2397 4.15098 18.2397 3.58302 18.0251 3.08097C17.8733 2.72586 17.5533 2.40587 16.9133 1.76588L16.9133 1.76587C16.2733 1.12588 15.9533 0.805878 15.5982 0.654102C15.0962 0.439518 14.5282 0.439518 14.0262 0.654102C13.6711 0.805878 13.3511 1.12587 12.7111 1.76587L10.7634 3.71352C11.7782 5.44596 13.2342 6.89039 14.9902 7.89131ZM9.30905 5.16788L2.01121 12.4657C1.58615 12.8908 1.37362 13.1033 1.23388 13.3644C1.09415 13.6255 1.0352 13.9202 0.917314 14.5097L0.251352 17.8395C0.18483 18.1721 0.151569 18.3384 0.246177 18.433C0.340785 18.5276 0.50709 18.4944 0.8397 18.4278L4.16951 17.7619C4.75896 17.644 5.05369 17.585 5.31479 17.4453C5.57588 17.3056 5.78841 17.093 6.21346 16.668L6.21347 16.668L13.5319 9.34955C11.827 8.28417 10.3854 6.85295 9.30905 5.16788Z",
    fill: "#F89500"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_1127_7368",
    x: 0.1875,
    y: 0.493164,
    width: 18.3319,
    height: 18.3319,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.333328,
    dy: 0.333328
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.666656
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.19534 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1127_7368"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.e1f73c29b72ff675db75d07f2bbb4f84.svg";
export { ForwardRef as ReactComponent };